import React, {useEffect, useRef, useState} from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useDispatch } from "react-redux";
import { ScrollActions } from "../../store/Slices/ScrollSlice";
//components
import LandingContainer from './LandingContainer/LandingContainer';

//styles
import classes from "./Landing.module.css"



//this component renders the Landing Section
const Landing = () =>{
  gsap.registerPlugin(ScrollTrigger)
  const dispatch = useDispatch();
  const container = useRef(null)

  const [width,setWidth] = useState(1500)

  const handleWidthChange =()=>{
    setWidth(window.innerWidth)
  }
  //creates a parallax effect 
  useEffect(() => {
    setWidth(window.innerWidth)
    window.addEventListener('resize',handleWidthChange)
    gsap.to(container.current,{
      yPercent:30,
      scrollTrigger:{
        trigger: container.current,
        start:"bottom 80%",
        // markers:true,
        scrub: true,
      }
    })
    let trigger1 = ScrollTrigger.create({
      trigger: container.current,
      start: "top bottom",
      end: "bottom bottom",
      scrub: true,
      // markers: true,
      onUpdate: (self) => {
        // console.log("progress", self.progress);
        dispatch(ScrollActions.UpdateLanding(self.progress));
      },
    });
    let trigger2 = ScrollTrigger.create({
      trigger: container.current,
      start: "bottom top",
      duration:1,
      scrub:true,
      // markers:true,
      onEnter: ()=>dispatch(ScrollActions.updateOpacity({opacity:1, x:0})),
      onEnterBack: ()=>dispatch(ScrollActions.updateOpacity({opacity:0,x:-200})),
    });

    return ()=>{
      trigger1.kill();
      trigger2.kill();
    }

    // eslint-disable-next-line
  },[])

    return <div className={classes.container} ref={container}>
      <LandingContainer/>
    </div>
}

export default Landing